var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTip4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5744 47.9239H46.5796C46.422 47.9239 46.2959 47.7745 46.2959 47.5876V43.2163H49.8266V47.5876C49.8266 47.7745 49.7005 47.9239 49.5744 47.9239Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.354 6.73291H48.0616V33.2131H45.7078C45.7078 33.2131 45.3715 16.2658 43.354 6.73291Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.769 6.73291H48.0615V33.2131H50.4153C50.4153 33.2131 50.7515 16.2658 52.769 6.73291Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.708 9.67508C45.708 8.37511 46.7618 7.32129 48.0618 7.32129V7.32129C49.3618 7.32129 50.4156 8.37512 50.4156 9.67508V43.5704C50.4156 44.675 49.5202 45.5704 48.4156 45.5704H47.708C46.6034 45.5704 45.708 44.675 45.708 43.5704V9.67508Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9457 -2.68262L42.1768 -2.68262V6.73254C42.1768 7.38253 44.8113 7.90944 48.0612 7.90944C51.3111 7.90944 53.9457 7.38253 53.9457 6.73254V-2.68262Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1209 -0.944396L55.1209 -49.1699C55.1209 -49.9981 54.6771 -50.4016 53.9509 -50.7565L51.3688 -52.0186L48.1008 -53.5566L44.4697 -51.8214L42.2104 -50.7565C41.4438 -50.4016 41 -49.6917 41 -48.8635L41 -0.917155C41 -0.267169 44.1615 0.259748 48.0614 0.259748C51.9613 0.259748 55.1227 -0.267169 55.1227 -0.917151C55.1227 -0.926257 55.1221 -0.93534 55.1209 -0.944396Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: -54,
    width: 15,
    height: 55
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1209 -0.944396L55.1209 -49.1699C55.1209 -49.9981 54.6771 -50.4016 53.9509 -50.7565L51.3688 -52.0186L48.1008 -53.5566L44.4697 -51.8214L42.2104 -50.7565C41.4438 -50.4016 41 -49.6917 41 -48.8635L41 -0.917155C41 -0.267169 44.1615 0.259748 48.0614 0.259748C51.9613 0.259748 55.1227 -0.267169 55.1227 -0.917151C55.1227 -0.926257 55.1221 -0.93534 55.1209 -0.944396Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: -50.9351,
    width: 3.53069,
    height: 51.195,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.5923,
    y: -50.9351,
    width: 3.53069,
    height: 51.195,
    fill: "#E5ECF0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.7509 71H20.1996L18.2173 71.8207V74.0448L19.9259 75.3662C20.0889 75.516 20.2188 75.6976 20.3073 75.8996C20.3958 76.1016 20.441 76.3196 20.4401 76.5398L24.5871 89.2771C24.6535 90.459 25.3004 91.3946 26.0718 91.3946H74.0114C74.7828 91.3946 75.4297 90.459 75.4878 89.2771L79.6348 76.548C79.6368 76.3302 79.6826 76.115 79.7694 75.915C79.8563 75.7149 79.9825 75.5339 80.1408 75.3826L81.7996 74.0448V71.8207L79.7509 71Z",
    fill: "#2E85EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1173 74.2827H19.7826L18.4409 75.8479V78.3417L20.153 80.0216C20.3147 80.2084 20.4442 80.4355 20.5334 80.6887C20.6227 80.9418 20.6697 81.2156 20.6716 81.4929L18.8772 92.9708C18.943 94.442 19.5851 95.6211 20.3588 95.6211H79.1217C79.8954 95.6211 80.5374 94.442 80.595 92.9708L79.3274 81.4929C79.3272 81.2172 79.3717 80.9443 79.458 80.6912C79.5444 80.4381 79.6709 80.2102 79.8295 80.0216L81.4758 78.3417V75.8479L76.1173 74.2827Z",
    fill: "#0F3251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9879 94.8003H20.1001V99.7245H78.9879V94.8003Z",
    fill: "#143C6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1484 76.7119L17.9019 83.3678L21.3024 95.818L22.447 97.4266L23.8324 94.8003L22.1484 76.7119Z",
    fill: "#164E93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5444 76.7119L81.7992 83.3678L78.3904 95.818L77.2458 97.4266L75.6699 94.3899L77.5444 76.7119Z",
    fill: "#164E93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2153 81.8744C80.2153 81.8744 81.5921 83.0644 81.5672 83.5158L77.8846 94.858C77.8349 95.9085 77.2543 96.7456 76.5659 96.7456H22.9365C22.2481 96.7456 21.6675 95.9249 21.6094 94.858L17.9186 83.5076C17.9186 83.0562 19.2207 81.8662 19.2207 81.8662L19.1544 80.2822H6V86.3801L8.3804 88.2349C8.60873 88.4439 8.7902 88.6979 8.91307 88.9807C9.03593 89.2634 9.09747 89.5685 9.09369 89.8763L14.8995 107.062C14.9825 108.703 15.8865 110.016 16.9565 110.016H83.1348C84.213 110.016 85.1005 108.712 85.1917 107.062L90.9478 89.8763C90.9464 89.5697 91.0083 89.266 91.1295 88.9838C91.2507 88.7015 91.4287 88.4467 91.6528 88.2349L93.9917 86.3719V80.2904H80.3646L80.2153 81.8744Z",
    fill: "#2E85EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.7509 71H20.1996C20.1166 71.0492 18.2173 71.8207 18.2173 71.8207H81.7747C81.7747 71.8207 79.8173 71.0985 79.7509 71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.652 74.6521H73.3642C73.4362 74.5972 73.514 74.5504 73.5964 74.5126L74.9152 73.9873H25.0762L26.4198 74.5044C26.5099 74.5305 26.5906 74.5818 26.652 74.6521V74.6521Z",
    fill: "#0B1C30"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.05811 86.4788L8.41362 88.3254C8.63773 88.5367 8.8153 88.7916 8.93518 89.0741C9.05507 89.3565 9.1147 89.6605 9.11032 89.9668L14.8747 107.111C14.9576 108.753 15.8534 109.992 16.9233 109.992H20.8132L19.1544 109.245C17.3049 108.318 16.0193 105.724 15.928 102.737L12.4031 81.8828H6.05811V86.4788Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M85.2081 107.111L90.9476 89.9585C90.9515 89.6579 91.0167 89.3613 91.1392 89.0863C91.2618 88.8113 91.4392 88.5636 91.6609 88.3581L93.9998 86.5115V81.9155H87.6963L84.163 102.737C84.0635 105.724 82.7779 108.26 80.9283 109.188L79.2695 109.959H83.1346C84.2294 109.959 85.1169 108.753 85.2081 107.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.401 77.4014H15.7373L6.05811 80.2903H19.1627L23.401 77.4014Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1182 77.4014H84.321L94.0085 80.2903H80.3647L76.1182 77.4014Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4009 77.4014L19.1543 80.2903L19.2124 81.8824L23.4589 78.7391L23.4009 77.4014Z",
    fill: "#1B5FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5952 73.8726L23.4009 74.7097V77.139L23.4589 78.7311L24.5372 77.8776L24.5952 73.8726Z",
    fill: "#1B5FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9155 73.8726L76.1182 74.7097L76.1099 77.139L76.0518 78.7311L74.9819 77.8776L74.9155 73.8726Z",
    fill: "#1B5FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1181 77.4014L80.3647 80.2903L80.3066 81.8824L76.0601 78.7391L76.1181 77.4014Z",
    fill: "#1B5FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.321 74.7095H76.1182V77.4014H84.321V74.7095Z",
    fill: "#2E85EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.401 74.7095H15.7456V77.4014H23.401V74.7095Z",
    fill: "#2E85EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9155 73.8726H81.5757L84.321 74.7097H76.1182L74.9155 73.8726Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5954 73.8726H18.4826L15.7373 74.7097H23.401L24.5954 73.8726Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.8641 86.4048H6L8.3804 88.235C8.56732 88.3557 8.71212 88.5305 8.7951 88.7356H19.6188L18.8641 86.4048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.6464 86.4048L79.8916 88.7356H91.2711C91.3843 88.5594 91.5179 88.3969 91.6692 88.2514L94.0081 86.4048H80.6464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.9186 83.5076C17.9147 83.4914 17.9147 83.4746 17.9186 83.4584C18.0339 83.0715 18.2725 82.7318 18.5987 82.4899L19.2125 81.9072H6.05811V84.6238H18.2836L17.9186 83.5076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.2485 81.8828L80.8623 82.4655C81.1848 82.7197 81.4195 83.0667 81.5341 83.4586C81.5302 83.4748 81.5302 83.4916 81.5341 83.5078L81.1692 84.624H94.0001V81.8828H80.2485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8894 96.7456H22.9365V97.4268H76.8894V96.7456Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.588 97.4268C22.4138 97.1478 22.2397 96.8523 22.0655 96.5569C19.8892 92.782 18.4804 88.6222 17.9185 84.3119V83.4912L21.5927 94.8498L22.588 97.4268Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M78.5152 100.193H21.3027L22.9367 97.4268H76.8812L78.5152 100.193Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8809 97.4268C77.0633 97.1478 77.2375 96.8523 77.4117 96.5569C79.5849 92.7806 80.9935 88.6214 81.5587 84.3119C81.5587 84.0411 81.5587 83.7703 81.5587 83.4912L77.8844 94.858L76.8809 97.4268Z",
    fill: "#589EF4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.4485 93.8902L60.975 94.2745L51.9648 66.2612L56.631 65.0444L62.4485 93.8902Z",
    fill: "#DDC55E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.5612 65.8449L51.9648 66.2612L60.975 94.2745L61.7118 94.0824L53.5612 65.8449Z",
    fill: "#ECD99F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.0353 65.4604L56.5089 65.0761L62.4492 93.89L61.5896 94.1141L55.0353 65.4604Z",
    fill: "#ECD99F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M52.7016 66.0691L51.9648 66.2612L60.975 94.2745L61.0978 94.2425L52.7016 66.0691Z",
    fill: "#ECD383"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.8949 65.236L62.3265 93.9217L62.4493 93.8897L56.6317 65.0439L55.8949 65.236Z",
    fill: "#ECD383"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.7948 66.1747L56.7267 65.4106L52.0605 66.6274L52.2515 67.3595L56.7948 66.1747Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.9758 65.8667L52.0641 67.1476L50.0093 60.7769L55.535 59.3359L56.9758 65.8667Z",
    fill: "#ECD383"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M51.605 60.3608L53.6598 66.7316L55.2561 66.3153L53.9381 59.7524L51.605 60.3608Z",
    fill: "#FCE19D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.7256 60.0678L55.5938 59.0597L49.9453 60.5327L50.1999 61.5088L55.7256 60.0678Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.9996 59.6054L49.8599 61.2065L46.3096 49.1011L53.0632 47.3399L55.9996 59.6054Z",
    fill: "#ECD383"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.1514 48.6211L51.5789 60.7586L54.4031 60.0221L51.5896 47.7245L48.1514 48.6211Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.5881 49.4189L49.7285 49.6431L52.5604 60.5024L53.42 60.2783L50.5881 49.4189Z",
    fill: "#FCE19D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M59.9017 87.6479L54.0923 66.8794L55.0746 66.6232L59.9017 87.6479Z",
    fill: "#FCE19D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.4771 48.9262L53.2817 47.674L46.4053 49.4673L46.7235 50.6874L53.4771 48.9262Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.3676 47.0001L46 48.9214L46.3818 50.3856L53.7494 48.4642L53.3676 47.0001Z",
    fill: "#ECD383"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 80.3574,
    r: 13,
    fill: "#F3F8EF",
    stroke: "#84BE60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1206,
    y: 80.9097,
    width: 6.84768,
    height: 3,
    transform: "rotate(45 72.1206 80.9097)",
    fill: "#5F9340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.0688,
    y: 75.979,
    width: 17,
    height: 3,
    transform: "rotate(135 87.0688 75.979)",
    fill: "#5F9340"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 38,
    y: -69,
    width: 20.1227,
    height: 169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 3,
    y: 70,
    width: 94,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 49.909,
    y1: 100.193,
    x2: 49.909,
    y2: 97.4268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 39,
    fill: "white",
    transform: "translate(6 71)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip4);
export default __webpack_public_path__ + "static/media/tip4.1f7fe0f1b1043485817a9f6326a24a8d.svg";
export { ForwardRef as ReactComponent };